// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2niSm","cell":"ColumnAccessor_cell__2xmcF","firstCellAccent":"ColumnAccessor_firstCellAccent__1Qlv0"};